import React from "react";
import { Editor } from "react-draft-wysiwyg";
import InputField from "@_common/InputRuleFeild";
import { getValue } from "@utils/lodash";
import { CopyToClipboard } from "@_common/text-helpers";

function EmailTemplateEditPopup(props: any) {
  const {
    showUpdatePopup,
    setShowUpdatePopup,
    request,
    submitLoading,
    editId,
    setRequest,
    editorState,
    onEditorStateChange,
  } = props;

  const handleSubmit = () => {
    console.log("wwwwwwwwwwwwwwww");
    localStorage.setItem("email_content", request.email_content || "");

    props.handleSubmit();
  };

  const handleChangeText = (e: any) => {
    console.log(e.target.name, e.target.value);

    setRequest((prev: any) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <div
      className={`compelte-task-wrapper ${
        showUpdatePopup ? "compelte-task-wrapper--active" : ""
      }`}
    >
      <div className="compelte-task-wrapper__header d-flex align-items-center justify-content-between">
        <h6 className="compelte-task-wrapper__title">Email Template</h6>
        <img
          src="/images/close-white.svg"
          className="img-fluid navigation-bar-wrapper__close-btn"
          onClick={() => {
            setShowUpdatePopup(false);
          }}
        />
      </div>

      {/* <div className="compelte-task-wrapper__body d-flex h-100"></div> */}
      <div className="d-flex max-height-mail-template email-template-wrapper">
        <div className="user-details-wrapper m-0 email-template-editable-content-holder flex-3">
          <div className="email-template-editable-content">
            <div className="checkpoint-active-details-wrapper__form-wrapper">
              <div className="checkpoint-active-details-wrapper__form-content_email_template">
                {/* <h4 className="mt-3 mb-3">New task assigned)</h4> */}
                <div className="modal-grid">
                  <div className="modal-input-grid-item mt-0 form-group">
                    <label className="checkpoint-active-details__label">
                      Template Type
                    </label>
                    <div className="filter-form-wrappper__location-input">
                      <InputField
                        inputType="INPUT_REACT_SELECT_MODAL"
                        placeholder="Choose Type"
                        // className="form-control w-100"
                        name="state_id"
                        id="state_id"
                        options={getValue(props, `typeList`, [])}
                        value={getValue(props, `typeList`, []).filter(
                          (item: any) =>
                            getValue(item, `value`, "") ==
                            getValue(request, `type`, ""),
                        )}
                        class={"model-grid__form-control"}
                        onChange={(e: any) => {
                          props.getKeys(getValue(e, `value`, ""));
                          setRequest({
                            ...request,
                            type: getValue(e, `value`, ""),
                          });
                        }}
                        isClear
                      />
                    </div>
                  </div>

                  <div className="user-details-wrapper__form-group form-group">
                    <label className="checkpoint-active-details__label">
                      Subject <span className="text-danger">*</span>
                    </label>
                    <InputField
                      inputType="TEXTAREA"
                      placeholder="Enter Subject"
                      className="form-control w-100"
                      name="subject"
                      id="subject"
                      value={getValue(request, `subject`, "")}
                      onChange={(e: any) => handleChangeText(e)}
                      label="Vendor Name"
                      // validator={simpleValidator}
                    />
                  </div>
                </div>
                <div className="user-details-wrapper__form-group form-group">
                  <div className="d-flex justify-content-between">
                    <label className="checkpoint-active-details__label">
                      Email Content <span className="text-danger">*</span>
                    </label>
                    {/* <label
                            style={{
                            fontSize: "15px",
                            color: "#266ef1",
                            fontWeight: "500",
                            cursor: "pointer",
                            }}
                            onClick={() => setShowUpdatePopup(!showUpdatePopup)}
                        >
                            Insert Placeholder
                        </label> */}
                  </div>
                  <Editor
                    editorState={editorState}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editorClassName"
                    onEditorStateChange={onEditorStateChange}
                    // placeholder={"Enter Email Content"}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="compelte-task-wrapper__cta d-flex align-items-center">
            <button
              className="ascent-button ascent-button--primary"
              onClick={() => setShowUpdatePopup(false)}
            >
              Cancel
            </button>
            <button
              className="ascent-button ascent-button--secondary"
              onClick={() => handleSubmit()}
              disabled={submitLoading}
            >
              {submitLoading ? "Please wait..." : editId ? "Update" : "Create"}
            </button>
          </div>
        </div>
        {/* <div style={{ marginLeft: "30px" }}></div> */}
        <div className="user-details-wrapper email-template-non-editable-content-holder flex-1">
          <p className="key-header">Placeholders</p>
          <div className="d-flex keys-container">
            {getValue(props, `keysInfo.keys`, []).map((item: any) => {
              return (
                <div
                  className="key-title-container"
                  onClick={() => CopyToClipboard(`<%= ${item} %>`)}
                >
                  <p className="key-title">{item}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmailTemplateEditPopup;
